import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

const StoreTileSection = (_param)=>{
    var { asideSlot , children , className , marginBottom  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "asideSlot",
        "children",
        "className",
        "marginBottom"
    ]);
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-tile__section', className, {
            [`mb--${marginBottom}`]: marginBottom
        })
    }), asideSlot ? /*#__PURE__*/ React.createElement("div", {
        className: "store-tile__section-wrapper"
    }, /*#__PURE__*/ React.createElement("div", null, children), /*#__PURE__*/ React.createElement("div", {
        className: "store-tile__section--aside"
    }, asideSlot)) : children);
};
var StoreTileSection$1 = StoreTileSection;

export { StoreTileSection$1 as default };
//# sourceMappingURL=StoreTileSection.js.map
